module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-edit-0b3f3e4dd1d41c8e339a96d37260a6a7.png";